import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { Grid, Typography, Box, Button } from '@mui/material';

import {
  DISPUTES_ACTIONS,
  DISPUTES_FILTERS,
  getSubmitDisputeError,
  getSubmitDisputesFlags
} from './utils';
import DisputeActionOptions from './DisputeActionOptions';
import TermAndConditionPopUp from './TermAndConditionPopUp';

const DisputeActions = ({ selectedDispute }) => {
  const history = useHistory();
  const messageRef = useRef('');

  const [disputeError, setDisputeError] = useState('');
  const [selectAction, setSelectAction] = useState(DISPUTES_ACTIONS.SEND);
  const [openTermsAndConditionModal, setOpenTermsAndConditionModal] = useState(false);
  const [shouldAcceptTermsAndConditions, setAcceptTermsAndConditions] = useState(false);

  const { selectedDisputes, disputes } = useSelector(store => store.disputes);
  const user = useSelector(store => store.user);
  const { disputeTermsAccepted } = useSelector(store => store.house) || {};

  const isSuperUser = user.isSuperUser !== null;

  const disputeSubmitHandler = ({ sendMessage, selectAction, disputeTermsAccepted }) => {
    if (!selectedDisputes.length)
      return setDisputeError('Please select a dispute using the checkboxes above.');

    const flags = getSubmitDisputesFlags(disputes, selectedDisputes);
    const error = getSubmitDisputeError({ flags, isSuperUser, selectAction, sendMessage });

    if (error) return setDisputeError(error);

    if (selectAction === DISPUTES_ACTIONS.CLOSE && !isSuperUser && !disputeTermsAccepted) {
      setAcceptTermsAndConditions(true);
      setOpenTermsAndConditionModal(true);
      return;
    }

    const { disputeArray } = flags;

    history.push('/customers/confirmDisputeAction', { disputeArray, selectAction, sendMessage });
  };

  return (
    <Grid mt={3}>
      <DisputeActionOptions
        ref={messageRef}
        selectAction={selectAction}
        setSelectAction={setSelectAction}
        showReOpenOption={isSuperUser && selectedDispute !== DISPUTES_FILTERS.OPEN_DISPUTES}
        showCloseAndCancelOption={
          selectedDispute !== DISPUTES_FILTERS.PAST_SIX_MONTHS &&
          selectedDispute !== DISPUTES_FILTERS.PAST_YEAR
        }
        openTermsAndConditions={() => setOpenTermsAndConditionModal(true)}
      />
      <Box mt={3} mb={4}>
        <Button
          className="submit-action"
          variant="contained"
          onClick={() => {
            disputeSubmitHandler({
              sendMessage: messageRef.current.value || '',
              selectAction,
              disputeTermsAccepted
            });
          }}
        >
          Submit Action
        </Button>
        <Typography variant="body2" component="span" ml={2}>
          (You can review before completing)
        </Typography>
        {disputeError && (
          <Typography variant="body2" color="red" mt={2}>
            {disputeError}
          </Typography>
        )}
      </Box>
      <TermAndConditionPopUp
        open={openTermsAndConditionModal}
        closeModal={() => setOpenTermsAndConditionModal(false)}
        onContinue={() => {
          disputeSubmitHandler({
            sendMessage: messageRef.current.value || '',
            selectAction,
            disputeTermsAccepted: true
          });
        }}
        shouldAcceptTermsAndConditions={shouldAcceptTermsAndConditions}
      />
    </Grid>
  );
};

export default DisputeActions;
